import { render, staticRenderFns } from "./district.vue?vue&type=template&id=0faa98c9&scoped=true&lang=html&"
import script from "./district.vue?vue&type=script&lang=js&"
export * from "./district.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0faa98c9",
  null
  
)

export default component.exports